import useSWR from 'swr'

export default function useCurrentUser() {
  const { data: user, error, isValidating } = useSWR('auth/me')

  return {
    user: user?.data,
    isLoading: isValidating,
    isError: error
  }
}
